/**
 * Created by rathompson on 11/5/21
 * File: link
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */


import type { MouseEventHandler, VFC } from 'react'
import { classNames } from '@panwds/react-ui'

/**
 *   Link text component
 */
const Link: VFC<{
  children: any,
  onClick?: MouseEventHandler<HTMLAnchorElement>,
  href?: string,
  target?: string,
  addClassName?: string,
  size?: 'sm' | 'md' | 'lg'
}> = ({ children, onClick, href, target, addClassName, size = 'md' }) => {

  const className = classNames(
    'cm-text-link',
    ['md', 'lg'].includes(size) ? 'cm-text-base' : 'cm-font-normal',
    'cm-cursor-pointer',
    'cm-truncate',
    addClassName
  )

  return <a {...{ onClick, href, target, className }}>
    {children}
  </a>
}

Link.propTypes = {}
export default Link
